import type { DynamicClient } from '../../../client/types';
import { emitEvent } from '../../clientEvents';
import { getWalletAccounts } from '../getWalletAccounts';

/**
 * Emits the `walletAccountsChanged` event.
  * @notInstrumented
 */
export const emitWalletAccountsChangedEvent = (client: DynamicClient): void => {
  const walletAccounts = getWalletAccounts(client);

  emitEvent(
    {
      args: { walletAccounts },
      event: 'walletAccountsChanged',
    },
    client
  );
};
